//import React from 'react';

import React, { useState} from 'react';  
//import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
//import { fetchProducts } from '../../redux/slices/ProductsSlice';
//import { addToWishList, removeFromWishList } from '../../redux/slices/AuthSlice';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import {Modal} from 'react-bootstrap'
import paths from '../../routes/paths'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faPlus,faMinus } from '@fortawesome/free-solid-svg-icons';
import { faHeart } from '@fortawesome/free-regular-svg-icons'; 
import { addToCart } from '../../redux/slices/CartSlice'; 
import { toast } from 'react-toastify'; 
import RadioButton from '../Common/RadioButton'
import YouTubeShorts from '../Common/YouTubeShorts';
import parse from 'html-react-parser';
import ProductImageSlider from '../Products/ProductImageSlider';


const  ProductViewModal = ({selectedProduct,modalShow,onClose,wishListData,wishlistIds}) => {
 //const [quantity, setQuantity] = useState(1);
 const dispatch = useDispatch<ThunkDispatch<any,any,any>>(); 
 const [sizeError, setSizeError] = useState("");
 //const [allSizes, setAllSizes] = useState(selectedProduct.variants.map { |variant| variant["size"] }.uniq);
 const [selectedSize, setSelectedSize] = useState('');


 

//  const increaseQty = () => {
//     if (quantity < 5){
//       const qty = quantity + 1
//       setQuantity(qty)
//     }
// }
// const decreaseQty = () => {
//   if (quantity > 1){
//     const qty = quantity - 1
//     setQuantity(qty)
//   }
// }

const addItemToCart = () => {
  
  if(selectedSize === ''){
    setSizeError('please select the size.')
  }  
  if(selectedSize !== ''){
    const variant = selectedProduct.variants.filter((variant) => variant.size === selectedSize)[0]
    //const qty = quantity+''
    const variant_id = variant.id
    const qty = '1';
    const price = variant.price
    const actualPrice = variant.actual_price
    //console.log("var",variant.price,variant)
    dispatch(addToCart({variant_id,qty,price,actualPrice,selectedSize}))
    onClose();
    toast.success("Item added to cart!"); 
  }
}
  
 

const manageSizeSelection = (size) => {
  //setQuantity(1);
  setSelectedSize(size); 
  setSizeError('');
}
//const uniqueSizes = Array.from(new Set(selectedProduct.variants.map(v => [v.size,v.out_of_stock])))
const uniqueSizes = selectedProduct.variants
  .map(variant => ({
    size: variant.size,
    out_of_stock: variant.out_of_stock
  })); 
  const desc = parse(selectedProduct['description']);
  const images = selectedProduct.variants[0].variant_images.map((image) => image.display_image_url)

  //const imageURL = process.env.REACT_APP_SERVER_URL + (selectedProduct.variants[0].variant_images[0]?.display_image_url)
//console.log("selected Values: " + selectedGender  + "  " + selectedCategory + "  ", selectedSize + "  " + selectedColor + " " + quantity+"   " + selectedPrice)
 //console.log("selected product ", selectedProduct, selectedSize)
return (
    
    <Modal size="xl" show={modalShow} onHide={onClose} className='quick-view-modal'>
      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}>
        <i className="icon feather icon-x"></i>
      </button>
      <Modal.Body> 
          <div className="row g-xl-4 g-3">
              <div className="col-xl-6 col-md-6">
                <div className="dz-product-detail mb-0">
                  <div className="swiper-btn-center-lr">
                    <div className="swiper quick-modal-swiper2">
                      <div className="swiper-wrapper" id="lightgallery">
                      
                        <div className="swiper-slide">
                          <div className={"dz-media DZoomImage "}>
                            <ProductImageSlider images={images} />
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>	
                </div>	
                {selectedProduct.variants[0].youtube_code && (
                        <div className="para-text p-4">
    
                          <h3>Please follow us on social media:</h3>
                          <ul className="social-account">
                              <li> <a href="https://www.instagram.com/anuughacollections" target="_blank" rel="noopener noreferrer" className="fs-14 cl3 hov-cl1 trans-04 lh-10 p-lr-5 p-tb-2 m-r-8  tooltip100" data-tooltip="Instagram"><i className="fab fa-instagram"></i></a> : <a className="main-color" href="https://www.instagram.com/anuughacollections" target="_blank" rel="noopener noreferrer">https://www.instagram.com/anuughacollections</a> </li>
                              <li> <a href="https://www.youtube.com/@anuughacollections" target="_blank" rel="noopener noreferrer" className="fs-14 cl3 hov-cl1 trans-04 lh-10 p-lr-5 p-tb-2 m-r-8  tooltip100" data-tooltip="Youtube"><i className="fab fa-youtube"></i></a> : <a className="main-color" href="https://www.youtube.com/@anuughacollections" target="_blank" rel="noopener noreferrer">https://www.youtube.com/@anuughacollections</a> </li>
                              <li> <a href="https://www.facebook.com/anuughacollections" target="_blank" rel="noopener noreferrer" className="fs-14 cl3 hov-cl1 trans-04 lh-10 p-lr-5 p-tb-2 m-r-8  tooltip100" data-tooltip="Facebook"><i className="fab fa-facebook"></i></a> : <a className="main-color" href="https://www.facebook.com/anuughacollections" target="_blank" rel="noopener noreferrer">  https://www.facebook.com/anuughacollections</a> </li>
                          </ul> 
                          <p className="yt-price-disclaimer"> Note: Prices mentioned in this video may differ from current website prices due to updates or promotions. Please refer to the product listings above for the most accurate pricing."</p>

                        </div> 
                      )}   	
              </div>
              <div className="col-xl-6 col-md-6">
                <div className="dz-product-detail style-2 ps-0 pt-2 mb-0">
                  <div className="dz-content">
                    <div className="dz-content-footer">
                      <div className="dz-content-start">
                     
                        <span className="badge bg-secondary mb-2">SKU: {selectedProduct.variants[0]['sku']}</span>
                        <h4 className="title mb-1"><a href="shop-list.html">{selectedProduct['name']}</a></h4>
                        <div className="review-num">
                          <ul className="dz-rating me-2">
                            <li className="star-fill">
                              <i className="flaticon-star-1"></i>
                            </li>										
                            <li className="star-fill">
                              <i className="flaticon-star-1"></i>
                            </li>
                            <li className="star-fill">
                              <i className="flaticon-star-1"></i>
                            </li>
                            <li>
                              <i className="flaticon-star-1"></i>
                            </li>
                            <li>
                              <i className="flaticon-star-1"></i>
                            </li>
                          </ul>
                          <span className="text-secondary me-2">4.7 Rating</span>
                          {/* <a href="#!">(5 customer reviews)</a> */}
                        </div>
                      </div>
                    </div>
                    <p className="para-text">
                      {desc}
                    </p>
                    <p className="para-text">
                        If you want more information or more photos about this product. please feel free to chat with us.  
                        <a rel="nofollow noopener noreferrer" target="_blank" href={"https://wa.me/+918499919988?text=https://anuughacollections.com/shop/"+ selectedProduct['id'] +  " Could you please provide more inforamtion about this product?"} title="connect with us" className="trans-04 p-lr-25 whatsapp-color-btn">
                            <span className="fab fa-whatsapp"></span>    
                              Whatsapp
                        </a>
                    </p>
                    <div className="widget m-b-10">
                          <h6 className="widget-title m-b-10">Size</h6>
                          <span className='errorMsg'>{sizeError}</span>
                          <div className="btn-group product-size m-b-10">
                            {uniqueSizes.map((size, index) =>  
                            <>
                              {size.out_of_stock === false &&  <RadioButton key={index} name="SizeSelection" id={"SizeSelection"+index} value={size.size} label={size.size}  inputClassName='btn-check' labelClassName="btn" checkedRadio={size.size === selectedSize ? "checked" : ""} selectedRadioValue={(value) => manageSizeSelection(value) } />}
                              {size.out_of_stock === true &&  <div className='btn disable-btn'>{size.size}</div> }
                              
                              </>
                            )}
                          </div>
                      </div>               
									  
                    <div className="meta-content m-b20 align-items-end">
                      
                     {selectedProduct.variants[0]['out_of_stock'] === true && 
                      	<button className="btn  flex-c-m stext-103 cl0 size-102 bg3 bor2 hov-btn1" >
                          Out of Stock
                        </button>
                      }
                    
										{ selectedProduct.variants[0]['out_of_stock'] === false && 
                     <>
                      {/*<div className="btn-quantity light me-3">
                         <label className="form-label m-r10">Quantity</label>
                        <button className="btn btn-default bootstrap-touchspin-down m-r10" type="button" onClick={() => decreaseQty()}><FontAwesomeIcon icon={faMinus}  /></button>
                        <div className="qty-value">{quantity} </div> 
                          <button className="btn btn-default bootstrap-touchspin-up m-l10" type="button" onClick={() => increaseQty()} ><FontAwesomeIcon icon={faPlus} /></button>
                        </div> */}
                    <div className="meta-content m-b20 d-flex align-items-end">
                        <div className="me-3">
                          <span className="form-label">Price</span>
                          <span className="price">₹{Math.round(selectedProduct.variants[0].price)} <del>₹{Math.round(selectedProduct.variants[0].actual_price)}</del></span>
                        </div>
                        
                      </div>
                    <div className=" cart-btn">
                      {  <button type='button' onClick={() => addItemToCart()} className="btn btn-secondary text-uppercase">Add To Cart</button>}

                      <button type='button' className="btn btn-md btn-outline-secondary"  onClick={() => wishListData(selectedProduct.id,(wishlistIds.includes(selectedProduct.variants[0].id) ? 'Remove' : "Add"))}> <FontAwesomeIcon icon={faHeart} className='p-r10' /> {wishlistIds.includes(selectedProduct.variants[0].id) ? "Remove From " : "Add To "}Wishlist </button>
                    </div>
                    </>
                    }
										</div>

                      
                     
                    <div className="dz-info mb-0">
                      <ul>
                        <li><strong>SKU:</strong></li>
                        <li>{selectedProduct['sku']}</li>
                      </ul>
                      <ul>
                        <li><strong>Category:</strong></li>
                        <li>
                          <Link to={paths.store}   className="stext-107 cl7 hov-cl1 trans-04">{selectedProduct['subcategory']['name']+" > "}</Link> 
                          <Link to={paths.subCategories(selectedProduct['sub_subcategory']['slug'])}   className="stext-107 cl7 hov-cl1 trans-04">{selectedProduct['sub_subcategory']['name']}</Link>
    
                        </li>	 											
                      </ul>
                      {/* <ul>
                        <li><strong>Tags:</strong></li>
                        <li><a href={paths.store}>Tshirt,</a></li>												
                        <li><a href={paths.store}>Custom Print,</a></li>												
                        <li><a href={paths.store}>Tshirt Print,</a></li>												
                        <li><a href={paths.store}>Print</a></li>												
                      </ul>  */}
                      {/* <SocialIcons/> */}
                      {selectedProduct.variants[0].youtube_code && <YouTubeShorts videoId={selectedProduct.variants[0].youtube_code} />}
                      {!selectedProduct.variants[0].youtube_code && (
                        <div className="para-text">
    
                          <h3>Please follow us on social media:</h3>
                          <ul className="social-account">
                              <li> <a href="https://www.instagram.com/anuughacollections" target="_blank" rel="noopener noreferrer" className="fs-14 cl3 hov-cl1 trans-04 lh-10 p-lr-5 p-tb-2 m-r-8  tooltip100" data-tooltip="Instagram"><i className="fab fa-instagram"></i></a> : <a className="main-color" href="https://www.instagram.com/anuughacollections" target="_blank" rel="noopener noreferrer">https://www.instagram.com/anuughacollections</a> </li>
                              <li> <a href="https://www.youtube.com/@anuughacollections" target="_blank" rel="noopener noreferrer" className="fs-14 cl3 hov-cl1 trans-04 lh-10 p-lr-5 p-tb-2 m-r-8  tooltip100" data-tooltip="Youtube"><i className="fab fa-youtube"></i></a> : <a className="main-color" href="https://www.youtube.com/@anuughacollections" target="_blank" rel="noopener noreferrer">https://www.youtube.com/@anuughacollections</a> </li>
                              <li> <a href="https://www.facebook.com/anuughacollections" target="_blank" rel="noopener noreferrer" className="fs-14 cl3 hov-cl1 trans-04 lh-10 p-lr-5 p-tb-2 m-r-8  tooltip100" data-tooltip="Facebook"><i className="fab fa-facebook"></i></a> : <a className="main-color" href="https://www.facebook.com/anuughacollections" target="_blank" rel="noopener noreferrer">  https://www.facebook.com/anuughacollections</a> </li>
                          </ul> 
                        </div> 
                      )}   	
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </Modal.Body> 
    </Modal>
      
  );
}

export default ProductViewModal;

 
